import { canais } from "../utils/canais"

/** Nome salvo ou número quando o contato ainda não tem nome legível. */
const resolverNomeExibicaoContato = (oContato) => {
  const cNome = (oContato?.name || oContato?.nome || "").trim()
  const cNumero = (oContato?.number || "").trim()
  if (!cNome) return cNumero
  const lNomePareceNumero = cNome.charAt(0) === "+" || !Number.isNaN(Number(cNome.charAt(0)))
  if (lNomePareceNumero && cNumero) return cNumero
  return cNome
}

/**
 * Retorna o nome e a foto de perfil a serem exibidos para uma conversa,
 * considerando se é uma conversa interna ou não.
 *
 * Para conversas internas (canalTipoId === canais.interno):
 * - Se o usuário logado é o responsável: mostra o outro participante (usuarioId)
 * - Se o usuário logado é o outro participante: mostra o responsável
 * - Se o usuário logado não é nenhum dos dois: mostra "Nome1 e Nome2"
 *
 * Para conversas normais: retorna os dados do contato
 *
 * @param {Object} oConversa - Objeto da conversa/ticket
 * @param {number} nUsuarioLogadoId - ID do usuário logado
 * @returns {Object} { cNome, cFoto, cEmpresa }
 */
const obterNomeContatoConversa = (oConversa, nUsuarioLogadoId) => {
  // Se não for conversa interna, retorna os dados do contato normalmente.
  // Listagem de Contatos usa nome/imagemPerfil; tickets usam name/profilePicUrl.
  if (!oConversa?.canalTipoId || oConversa.canalTipoId !== canais.interno) {
    const oContato = oConversa?.contact
    return {
      cNome: resolverNomeExibicaoContato(oContato),
      cFoto: oContato?.profilePicUrl || oContato?.imagemPerfil || "",
      cEmpresa: oContato?.empresa || undefined,
    }
  }

  // É conversa interna - trabalha com usuários
  const oResponsavel = oConversa?.responsavel
  const oUsuario = oConversa?.usuario

  // Se o usuário logado é o responsável, mostra o outro participante
  if (oResponsavel && oResponsavel.id === nUsuarioLogadoId) {
    return {
      cNome: oUsuario?.name || "Usuário",
      cFoto: oUsuario?.imagemPerfil || "",
      cEmpresa: undefined,
    }
  }

  // Se o usuário logado é o outro participante, mostra o responsável
  if (oUsuario && oUsuario.id === nUsuarioLogadoId) {
    return {
      cNome: oResponsavel?.name || "Responsável",
      cFoto: oResponsavel?.imagemPerfil || "",
      cEmpresa: undefined,
    }
  }

  // Se o usuário logado não é nenhum dos dois, mostra ambos os nomes
  const cNomeResponsavel = oResponsavel?.name || "Responsável"
  const cNomeUsuario = oUsuario?.name || "Usuário"

  return {
    cNome: `${cNomeResponsavel} e ${cNomeUsuario}`,
    cFoto: oResponsavel?.imagemPerfil || oUsuario?.imagemPerfil || "",
    cEmpresa: undefined,
  }
}

export default obterNomeContatoConversa
